import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking';

export const VIEW_GOAL_PICKER_EXPERIENCE: ExperienceDetails = {
	experience: 'viewGoalPicker',
	packageName: 'jiraBusinessGoalPicker',
	teamName: 'jira-yurree',
};
